import styled from 'styled-components';

export const BoxRecipe = styled.div`
  max-width: 757px;
  background: #fbfbfc;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  opacity: 1;
  padding: 20px;
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 24px;

  @media (max-width: 801px) {
    margin: ${(props) => props.theme.spacing.base};
  }
`;

export const RecipeTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
`;

export const RecipeTitle = styled.h2`
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #454f63;
  opacity: 1;
  margin: 0;
`;

export const RecipeData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 10px;
`;

export const TextData = styled.span`
  color: #78849e;
  font-size: 14px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  margin-bottom: ${(props) => props.marginBottom};
`;

export const ButtonRecipe = styled.button`
  width: ${(props) => props.width};
  height: 45px;
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 4px;
  opacity: 1;
  color: ${(props) => props.textColor};
  margin-left: ${(props) => props.marginLeft};
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  transition: all 0.3s ease 0s;
  :hover {
    box-shadow: 5px 5px 15px 5px #d6d6d6;
  }
`;

export const TitleMessage = styled.span`
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ed4343;
  opacity: 1;
  margin: 0 0 0 10px;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 480px) {
    span {
      display: none;
    }
  }
`;
